module.exports = __webpack_public_path__ + "static/media/108.7ac1c4f5.wav";